import { client } from './client';
import interceptors from './interceptors';
import qs from 'qs';

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function list(params) {
	return client.get('/tunnel/api/stockist/transaction/data', {
		params: params,
	});
}

function detail(trx_id) {
	return client.get('tunnel/api/stockist/transaction/detail', {
		params: {
			trx_id: trx_id
		}
	});
}

function summary() {
	return client.get('tunnel/api/stockist/transaction/summary');
}

function ApprovalOrder(params) {
	return client.post('tunnel/api/stockist/transaction/approvalorder', qs.stringify(params), {
		header: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}

function ApprovalRefund(params) {
	return client.put('tunnel/api/stockist/transaction/approval_refund', qs.stringify(params), {
		header: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}

function actNoResi(params) {
	return client.post('tunnel/api/stockist/transaction/addresi', qs.stringify(params), {
		header: {
			'Content-Type': 'aplication/x-www-form-urlencoded',
		},
	});
}

function actPickup(params) {
	return client.post('tunnel/api/stockist/transaction/pickup', qs.stringify(params), {
		header: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}

function getOptionDataSerial(params) {
	return client.get('/tunnel/api/stockist/stock/data-option-serial', {
		params: params,
	});
}

function checkSerialMLM(params) {
	return client.get("tunnel/api/stockist/transaction/check-serial", {
		params: params,
	});
}

export default {
	list,
	detail,
	summary,
	ApprovalOrder,
	ApprovalRefund,
	actNoResi,
	actPickup,
	getOptionDataSerial,
	checkSerialMLM
};